import isEqual from 'lodash/isEqual';

export function objectIsDifferent(oldObj, newObj) {
  return !isEqual(oldObj, newObj);
}
